<template>
    <div class="task-info">
        <div class="info-header">
            <span class="info-header-txt">拨号记录</span>
        </div>
        <div class="task-wrapper">
            <el-table :data="dialingRecordInfo" border class="task-list" width="100%" height="230">
                <el-table-column
                    v-for="(item, index) in tableColumn"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label"
                    :width="item.width"
                    :show-overflow-tooltip="true"
                    >
                </el-table-column>
        </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DialingRecord',
    props: {
        dialingRecordInfo: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            tableColumn: [
                { prop: 'callStartTime', label: '拨号时间' },
                { prop: 'privacyProtectName', label: '是否隐私保护', width: '200' },
                { prop: 'callConnectedName', label: '是否接通', width: '140' },
                { prop: 'callDuration', label: '通话时长(S)', width: '140' },
                { prop: 'dialledCalls', label: '主叫号码', width: '140' },
                { prop: 'privacyVirtualNum', label: '隐私号码' },
                { prop: 'createUserName', label: '操作人' }
            ]
        };
    }
};
</script>

<style lang="less" scoped>
@import '../appointmentDetail.less';
.task-info {
    background-color: #fff;
    margin-bottom: 10px;
}
.task-wrapper {
    padding: 10px;
}
</style>
